import Vue from 'vue';
import skyPrint from './sky-print';
// Main component
Vue.component('sky-print', skyPrint);

export default skyPrint;



// WEBPACK FOOTER //
// ./scripts/sky-print/index.js